import type { FaireThemeEntity } from "../../entity_types/theme";

export const california_urban_lifestyle: FaireThemeEntity = {
  token: "california-urban-lifestyle",
  type: "theme",
  name: "California Urban Lifestyle",
  description: "Incorporate local street culture into your boutique with active lifestyle gear. This theme bridges the gap between beauty services and the vibrant, active culture of San Jose.",
  teaser: "Being located in California and predicted as a clothing-leaning retailer, adding urban lifestyle accessories helps broaden your appeal to a younger, active demographic.",
  detail: "The inclusion of Hydroponic Skateboarding Griptape in your current cart suggests you are diversifying your inventory into street-inspired active gear.",
  bgColor: "#E8D5B7",
  tileBgColor: "#6b4736",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_kxshwxzjhj",
    "p_yjmgktu8c2",
    "p_y6p4uady87",
    "p_nat8nvr67c",
    "p_s2qycaaa74",
    "p_kqxpxjnydk",
    "p_hm48qy3ny4",
    "p_ubceywhbbb",
    "p_gpq3p2dduc",
    "p_85jt77d2xa",
    "p_cuwud2tvkp",
    "p_ssdpc949sz",
    "p_jbagyns275",
    "p_waj7mkq8ae",
    "p_g4p5euhdhu",
    "p_knx97ngxss",
    "p_npyf9j8adk",
    "p_g8f4yuznur",
    "p_ugzu8dnjc4",
    "p_ja7uc2dnz4",
    "p_4wppra3b8y",
    "p_712k9kkvs1",
    "p_hvubmpmb65",
    "p_r5d43nsxjp",
    "p_6jqbe5sgjp",
    "p_8jpss9zd35",
    "p_93mvn7w4pf",
    "p_t9tt33bgz3",
    "p_x3cuyvze66",
    "p_nz7euf94ma",
    "p_kcvj8n2f46",
    "p_4hdffrs9us",
    "p_fcwgh4the5",
    "p_34aqgf7bzc",
    "p_wwpg9zkt3x",
    "p_7x6hvuzygf",
    "p_s94hgxza2p",
    "p_thjurwat8x",
    "p_4fmk5naztn",
    "p_vw2fn6fah6",
    "p_jhr8yxhz9n",
    "p_b2zrr3vg2q",
    "p_q358pn2p6r",
    "p_6n3acgn3tz",
    "p_j7jdtsamhk",
    "p_kd86dpdw4w",
    "p_gz5gmzu256",
    "p_uuw8327hrf",
    "p_dgcnr3tr8h",
    "p_8ppgrgz9j8",
    "p_7fwscp3cme",
    "p_frkjed326u",
    "p_q2y4f8fp35",
    "p_b4rm54a264",
    "p_n2vswd6p2x",
    "p_8etn3ggv8a",
    "p_5m2yezq3e7",
    "p_qbthqdbgpt",
    "p_kh5yw766n7",
    "p_n8eee6n2qd",
    "p_h2ww6ungg7",
    "p_r4ubha28r2",
    "p_day9fy2s3n",
    "p_jv32adyxhz",
    "p_9aqt8nwvmc",
    "p_8azzac2ram",
    "p_x8n3carygk",
    "p_w6chhwjp72",
    "p_kmndq4wdx7",
    "p_amdb42yyjx",
    "p_cduuk3etfq",
    "p_45seygkeux",
    "p_5bk22g9c87",
    "p_42jccpf3pc",
    "p_h7exzf22xd",
    "p_tpf2apke3k",
    "p_g5axa44u24",
    "p_6decuppm2u",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
